<template>
<v-main>
  <v-footer class="mt-5 pb-5 white--text" padless color="rgb(255, 255, 255, 0.03)">
    <v-container>

      <v-row>
        <v-col>
<!-- <div class="round"> -->

    <v-card
      flat
      tile
      color="transparent"
      
          >
          <v-card-title>
            <h3 style="color:#ffc20e">
             {{$t('maryud103fm')}}
             </h3> 
          </v-card-title>

          <v-card-text class="white--text">
            <p>{{$t('aboutcompL')}}</p>
          </v-card-text>
                   <v-row >
                     <v-container>

                       
                       
                       
                       <v-btn icon class="px-2 mx-2"
                 @mouseenter="playInstagram" @mouseleave="stopInstagram">

                   <lottie-animation  ref="instagram"
                               :animationData="icons[0].icon"
                               :loop="false"
                               :autoPlay="false"
                               class="icon"
                               >
                               
                               </lottie-animation>
               </v-btn>

               
               <v-btn icon class="px-2 mx-2"
                 @mouseenter="playFacebook" @mouseleave="stopFacebook">

                   <lottie-animation  ref="facebook" style="width:3em;"
                               :animationData="icons[2].icon"
                               :loop="false"
                               :autoPlay="false"
                               class="icon"
                               >
                               
                               </lottie-animation>
               </v-btn>

               <v-btn icon class="px-2 mx-2"
                 @mouseenter="playTwitter" @mouseleave="stopTwitter">

                   <lottie-animation  ref="twitter"
                               :animationData="icons[1].icon"
                               :loop="false"
                               :autoPlay="false"
                               class="icon"
                               >
                               
                               </lottie-animation>
               </v-btn>
                       </v-container>
             </v-row>


    </v-card>
    </v-col>
    
    <v-col>
      
    
    <!-- card2 -->
    
    
    
    <v-card
     flat
      tile
      color="transparent">

      <v-main>
        <v-card-title style="color:#ffc20e;">
          {{$t('menu')}}
        </v-card-title>
        <!-- <v-card-text> -->
          
          <ul>
            <v-btn text small color="primary" to='/'>
              {{$t('home')}}
           </v-btn> 
          </ul>
          <ul>
            <v-btn text small color="primary" to='/shows'>
              {{$t('shows')}}
             </v-btn> 
          </ul>
          <ul>
            <v-btn text small color="primary" to='/gallery'>
              {{$t('gallery')}}
             </v-btn> 
          </ul>
          <ul>
            <v-btn text small color="primary" to='/aboutus'>
             {{$t('about')}}
             </v-btn> 
          </ul>
          <ul>
            <v-btn text small color="primary" to='/contact'>
             {{$t('contact')}}
             </v-btn> 
          </ul>
        <!-- </v-card-text> -->

      </v-main>
    </v-card>
    </v-col>
    
    


    
    <!-- card3 -->
    
    
    
    
    <v-col>
      
      <v-card
     flat
      tile
      color="transparent">

      <v-content class="pt-0">
        <v-card-title style="color:#ffc20e;">
          {{$t('contactus')}}
        </v-card-title>
        <v-card-text>
          
          <p class="white--text" >

       <v-icon small color="primary">mdi-office-building-outline</v-icon>
       <!-- <v-spacer></v-spacer> -->
       {{$t('address')}}
        </p>
        
        <p class="white--text" >
          <v-icon small color="primary">mdi-email</v-icon>
         <!-- <v-spacer></v-spacer> -->
         contact@maryudfm.com
        </p>
        </v-card-text>

        
      </v-content>
          <v-row class="pa-5 justify-right">
            <p class="white--text">Powered by</p>
            <a>
              <v-img max-width="12em" contain  @click="routeTCE" class="mt-5n"  :src="require('../assets/TCE-Logo-Archivo---white-text.png')"></v-img>
            </a>
         </v-row>
              <v-card-text class="white--text" >
              <p>   {{ new Date().getFullYear() }}©<strong>Maryud103FM</strong> </p>
              </v-card-text>
           </v-card>
  <!-- </div> -->
    </v-col>
  </v-row>
            </v-container>
  </v-footer>
  </v-main>
    
</template>
<script>
import LottieAnimation from 'lottie-web-vue'

export default {
    name:'Footer',
    components:{
      LottieAnimation
    },
     data: () => ({
        icons: [{
          id:1,
          icon:require('../assets/Animations/instagram2.json'),
          link:'https://www.instagram.com/maryud103fm/',
          ref:'lottie1',
          play:'playAnim1',
          stop:'stopAnim1'
          
        },{
          id:2,
          icon:require('../assets/Animations/twitter.json'),
          link:'https://twitter.com/maryud103fm',
          ref:'lottie2',
          play:'playAnim2',
          stop:'stopAnim2'
        },{
          id:3,
          icon:require('../assets/Animations/facebook.json'),
          link:'https://www.facebook.com/Maryud103FM',
          ref:'lottie3',
          play:'playAnim3',
          stop:'stopAnim3'
        }
      ],
    }),
    methods:{
      playInstagram(){
        this.$refs.instagram.play()
      },
      playTwitter(){
        this.$refs.twitter.play()
      },
      playFacebook(){
        this.$refs.facebook.play()
      },
      stopInstagram(){
        this.$refs.instagram.stop()
      },
      stopTwitter(){
        this.$refs.twitter.stop()
      },
      stopFacebook(){
        this.$refs.facebook.stop()
      },
      routeTCE(){
        window.open('https://thecodeeffect.com')
      }
    }
    
}
</script>
<style>
.icon{
  width: 2em;
  height: 2em;
}
</style>